/**
 * Etkinlik takvimi — FullCalendar `events` dizisi.
 * `extendedProps.kind`: `weekly-meeting` (lacivert) | `event` (turuncu)
 */

/** @type {Record<string, unknown>[]} */
export const CALENDAR_EVENTS = [
    {
        groupId: 'weekly-club-meeting',
        title: 'Haftalık kulüp toplantısı',
        daysOfWeek: [4],
        startTime: '19:30:00',
        endTime: '21:30:00',
        startRecur: '2026-01-01',
        endRecur: '2027-12-31',
        backgroundColor: '#0E4D94',
        borderColor: '#0a3d78',
        textColor: '#ffffff',
        extendedProps: { kind: 'weekly-meeting' },
    },
    {
        title: 'Yönetim kurulu',
        start: '2026-04-12T10:00:00',
        end: '2026-04-12T12:00:00',
        backgroundColor: '#0E4D94',
        borderColor: '#0a3d78',
        textColor: '#ffffff',
        extendedProps: { kind: 'weekly-meeting' },
    },
    {
        title: 'Bahar sosyal buluşması',
        start: '2026-04-18T18:30:00',
        end: '2026-04-18T22:00:00',
        backgroundColor: '#e87722',
        borderColor: '#c45a12',
        textColor: '#ffffff',
        extendedProps: { kind: 'event' },
    },
    {
        title: 'Proje koordinasyon toplantısı',
        start: '2026-04-22T14:00:00',
        end: '2026-04-22T15:30:00',
        backgroundColor: '#0E4D94',
        borderColor: '#0a3d78',
        textColor: '#ffffff',
        extendedProps: { kind: 'weekly-meeting' },
    },
    {
        title: 'Konuk konuşmacı: sürdürülebilirlik',
        start: '2026-05-06T19:00:00',
        end: '2026-05-06T20:30:00',
        backgroundColor: '#e87722',
        borderColor: '#c45a12',
        textColor: '#ffffff',
        extendedProps: { kind: 'event' },
    },
    {
        title: 'Aile pikniği',
        start: '2026-05-24',
        end: '2026-05-25',
        allDay: true,
        backgroundColor: '#e87722',
        borderColor: '#c45a12',
        textColor: '#ffffff',
        extendedProps: { kind: 'event' },
    },
    {
        title: 'Rotary gece yemeği',
        start: '2026-06-14T19:00:00',
        end: '2026-06-14T23:00:00',
        backgroundColor: '#e87722',
        borderColor: '#c45a12',
        textColor: '#ffffff',
        extendedProps: { kind: 'event' },
    },
];
